const getNextOffset = (
    currentOffset: number,
    limit: number,
    totalItems: number
): number | null => {
    const nextOffset = currentOffset + Math.abs(limit);
    return nextOffset > totalItems ? null : nextOffset;
};

export default getNextOffset;
